import { useContext, useState } from 'react'
import _ from "lodash"

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import { PassImage } from '/components/editor/pass-image'

const HeroImage = () => {

    const { smartixPassType, variables, scannerData, device } = useContext(PassContext)
    const [imageHeight, setImageHeight] = useState(80)

    const imageLoaded = e => {
      const img = e.target
      const displayedImageHeight = ((370 / img.width) * img.height) + 5
      setImageHeight(displayedImageHeight)
    }

    const type = smartixPassType === "managed_stamp" ? "stamp-images" : "image"

    let heroImage = getHeroImage()
    
    const stampBalanceRaw = _.get(variables, "stamp.stamps.balance", 0)
    const stampBalance = Math.max(0, Number.parseInt(stampBalanceRaw, 10) || 0)
    const stampHeroImage = _.get(scannerData, ["stamp_images", device, stampBalance])
    const fallbackStampHeroImage = _.get(scannerData, ["stamp_images", device, 0])
    if (smartixPassType === "managed_stamp") {
      heroImage = {
        ...heroImage,
        value: stampHeroImage || fallbackStampHeroImage || heroImage?.value
      }
    }

    return (
      <div className="image" style={{ position: "relative", minHeight: 80 }}>
        <PopupEditor title="Hero Image" path={heroImage.path} sources={heroImage} type={type}>
          {heroImage?.value &&
            <>
              <div style={{ position: "absolute", height: imageHeight, width: "100%" }} className="editable" />
              <PassImage src={heroImage.value} className="hero" onLoad={e => imageLoaded(e)} />
            </>}
          <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", bottom: 10, right: 10, zIndex: 1 }} />
        </PopupEditor>
      </div>
    )
}

export default HeroImage

const getHeroImage = () => {
  try {

    const { objectData, variables, passType } = useContext(PassContext)

    switch (passType) {
      case "generic":
        {
          return {
            template_source: "object",
            source: "object",
            path: "heroImage.sourceUri.uri",
            value: dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" })
          }
        }

      case "eventTicket":
      case "flight":
      case "transit":
      case "offer":
      case "loyalty":
      case "giftCard": {
        return {
            template_source: "object",
            source: "object",
            path: "heroImage.sourceUri.uri",
            value: dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" })

// Only using object sp we can use our variables to update...

//          template_source: "class",
//          source: objectData.heroImage ? "object" : "class",
//          path: "heroImage.sourceUri.uri",
//          value: objectData.heroImage ? dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" }) : dataSelector({ objectData:classData, variables, path: "heroImage.sourceUri.uri" })
        }
      }
    }
  }
  catch (err) {
    console.error("Error destructuring hero path")
  }
}
